import React, { SVGProps } from 'react';

/* eslint-disable max-len */
const SvgStressedOutOwl: React.FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 382 474" {...props}>
    <g fill="none" fillRule="nonzero">
      <g transform="translate(232)">
        <circle fill="#007FBF" cx={75} cy={80} r={75} />
        <circle fill="#009DFF" cx={75} cy={75} r={75} />
        <circle fill="#F9F9F9" cx={75.5} cy={75.5} r={62.5} />
        <rect fill="#B8B8B8" x={72} y={19} width={6} height={15} rx={3} />
        <rect fill="#B8B8B8" x={72} y={116} width={6} height={15} rx={3} />
        <rect fill="#B8B8B8" transform="rotate(90 123.5 75)" x={120.5} y={67.5} width={6} height={15} rx={3} />
        <rect fill="#B8B8B8" transform="rotate(90 26.5 75)" x={23.5} y={67.5} width={6} height={15} rx={3} />
        <rect fill="#B8B8B8" transform="rotate(30 99.75 32.13)" x={98.75} y={27.63} width={2} height={9} rx={1} />
        <rect fill="#B8B8B8" transform="rotate(30 50.25 117.87)" x={49.25} y={113.37} width={2} height={9} rx={1} />
        <rect fill="#B8B8B8" transform="rotate(60 117.87 50.25)" x={116.87} y={45.75} width={2} height={9} rx={1} />
        <rect fill="#B8B8B8" transform="rotate(60 32.13 99.75)" x={31.13} y={95.25} width={2} height={9} rx={1} />
        <rect fill="#B8B8B8" transform="rotate(120 117.87 99.75)" x={116.87} y={95.25} width={2} height={9} rx={1} />
        <rect fill="#B8B8B8" transform="rotate(120 32.13 50.25)" x={31.13} y={45.75} width={2} height={9} rx={1} />
        <rect fill="#B8B8B8" transform="rotate(150 99.75 117.87)" x={98.75} y={113.37} width={2} height={9} rx={1} />
        <rect fill="#B8B8B8" transform="rotate(150 50.25 32.13)" x={49.25} y={27.63} width={2} height={9} rx={1} />
        <path
          d="M103.13 56.67c-.97-1.38-11.04 4.24-20.46 11.36-16.29 12.32-15.8 16-15.4 16.59.48.66 4.64.66 19.44-10.87 8.85-6.9 17.4-15.71 16.42-17.08z"
          fill="#404040"
        />
        <path
          d="M51.47 36.3c-1.8 1.03 3.94 14.24 11.44 26.85 12.98 21.8 17.4 21.68 18.15 21.25.88-.5.78-4.96-11.43-24.8-7.3-11.88-16.34-24.32-18.16-23.3z"
          fill="#404040"
        />
      </g>
      <g fill="#404040">
        <path d="M138.63 104.89c0 .96-.19 1.86-.57 2.72-.38.86-.9 1.61-1.54 2.26a7.4 7.4 0 01-2.26 1.54c-.86.38-1.76.57-2.72.57-2 0-3.69-.68-5.05-2.04-1.36-1.36-2.04-3.04-2.04-5.05 0-2 .68-3.7 2.04-5.05 1.36-1.36 3.04-2.05 5.05-2.05.96 0 1.86.2 2.72.58.86.38 1.62.9 2.26 1.54.65.64 1.16 1.4 1.54 2.26.38.86.57 1.77.57 2.72zM126.9 91.4h11.73l6.43-63.4h-21.98z" />
      </g>
      <g>
        <g transform="translate(0 135)">
          <path
            d="M214.66 330.1c0-6.88-31.91-13.25-71.28-13.25-39.36 0-71.27 5.27-71.27 12.14 0 6.88 31.9 9.65 71.27 9.65s71.28-1.67 71.28-8.55z"
            fill="#000"
            opacity={0.28}
          />
          <path
            d="M249.08 63.67c-.82-17.87-4.48-30.94-4.48-30.94-4.82-27.86-11.79-19.85-31.17-7.98C192.2 9.47 166.18.45 138.03.45c-28.37 0-54.6 9.17-75.91 24.69C44.6 12.42 41.8 8 31.32 26.98c0 0-5.88 16.4-8.51 44.3-8.88 17.5-13.88 37.31-13.88 58.29 0 71.3 53.8 129.1 129.1 127.58 80.21-1.63 129.12-56.27 129.12-127.58 0-24.08-6.6-46.6-18.07-65.9z"
            fill="#D85700"
          />
          <path
            d="M249.08 63.67c-.82-17.87-4.48-30.94-4.48-30.94-4.82-27.86-11.79-19.85-31.17-7.98C192.2 9.47 166.18.45 138.03.45c-28.37 0-54.6 9.17-75.91 24.69C44.6 12.42 41.8 8 31.32 26.98c0 0-5.88 16.4-8.51 44.3-8.88 17.5-13.88 37.31-13.88 58.29 0 71.3 53.8 113.39 129.1 111.86 80.21-1.63 129.12-40.55 129.12-111.86 0-24.08-6.6-46.6-18.07-65.9z"
            fill="#FF7300"
          />
          <g transform="translate(141 68)">
            <circle cx={40.47} cy={41.08} r={40.29} fill="#D85700" />
            <circle fill="#FFF" cx={40.47} cy={46.41} r={40.29} />
          </g>
          <g transform="translate(40 68)">
            <circle cx={41.26} cy={41.22} r={40.62} fill="#D85700" />
            <circle fill="#FFF" cx={41.26} cy={46.59} r={40.62} />
          </g>
          <circle fill="#404040" cx={189.48} cy={98.37} r={11.46} />
          <circle fill="#404040" cx={95.89} cy={100.69} r={11.46} />
          <path
            d="M253.96 108.73s45.02 87.2 10.06 95c0 0-13.3.2-11.34-14.14 0 0-13.4-1.18-10.1-15.9 0 0-15.92.31-16.58-17.86 0 0-1.13-17.38 11.74-38.4 0 0 10.13-12.57 16.22-8.7zM21.46 117.87s-41.28 79.4-7.04 88.54c0 0 12.95.89 10.63-12.66 0 0 14.42-1.87 9.36-14.38 0 0 15.51 1.14 15.62-15.87 0 0 .6-16.23-12.54-36.62 0 0-10.23-12.31-16.03-9z"
            fill="#FF7300"
          />
        </g>
        <path
          d="M164 303.4L134.55 281c-12.9 7.22-28.55 18.5-28.55 18.5 2.66 4.75 28.55 18.5 28.55 18.5 2.26-.99 12.07-5.86 29.45-14.6z"
          fill="#404040"
        />
        <path
          d="M132.86 310.62c0-1.11-24.7-8.67-30.72-9.62-.38.51-1.37 2.26 19.2 17.2.66.6 4.71 3.1 12.16 7.51 12.7-10.49 21.85-16.91 27.43-19.27 5.2-2.2 4.02-2.7 3.8-3.14.13-2.24-12.12 1.12-21.62 4.04-4.7 1.44-8.73 2.78-10.25 3.28z"
          fill="#D85700"
        />
        <path
          d="M133 303.07c0-.75-9.2 2.8-27.79-1.25-3.37-1.18-4.09-1.09-2.15.27 2.61 1.83 7.48 4.98 14.59 9.45.66.58 5.8 2.74 15.44 6.46 14.91-7.59 25.15-12.56 30.7-14.93.31-.37.24-.81 0-1.25 0 0-26.23-.27-30.79 1.25z"
          fill="#F2F2F2"
        />
        <path
          d="M158.51 300.34c.61-.9-23.72-22.62-25.34-23.32-1.08-.46-9.09 6.06-24.02 19.58l-6.6 5.1c1.24 1.07 3.24 2.17 5.97 3.3 9.94 3 18.03 4.5 24.27 4.5 6.23 0 14.1-1.67 23.59-5 4.73-1.18 7.6-1.77 8.62-1.77l-6.49-2.39z"
          fill="#B8B8B8"
        />
        <path
          d="M133.17 275.02c-1.08-.46-9.09 6.06-24.02 19.58l-8.58 7.4c2 1.7 12.83 3.25 32.46 4.63 20.66-2.6 31.32-3.9 31.97-3.9-20.14-18-30.75-27.24-31.83-27.7z"
          fill="#FFF"
        />
      </g>
    </g>
  </svg>
);
/* eslint-enable max-len */

export default SvgStressedOutOwl;
